const filters = {
    reverseBum: function (val) {
        if (val && val.toString().includes('.')) {
            return val.toFixed(2);
        } else {
            return val || val === 0 ? val + '.00' : '';
        }
    },
    transNumberToShort: function (value, decimal = 0) {
        if (isNaN(value)) {
            return 0;
        }
        value = Number(value);
        const BASE = 10000;
        const SIZES = ['', '万', '亿', '万亿'];
        let i = undefined;
        let str = '';
        if (value < BASE) {
            str = value.toFixed(decimal);
        } else {
            i = Math.floor(Math.log(value) / Math.log(BASE));
            str = `${(value / Math.pow(BASE, i)).toFixed(decimal)}${SIZES[i]}`;
        }
        return str;
    },
};
export default filters;



// WEBPACK FOOTER //
// ./src/utils/filters.js